import { type UseMutationResult, useMutation } from '@tanstack/react-query';
import { PURCHASE_ORDER_PDF_PREVIEW_KEY } from '@/keys';
import { getPurchaseOrderPdfPreview } from '@/services/apis/queries/purchase-order/get-purchase-order-pdf-preview';

export const usePurchaseOrderPdfPreview = (): UseMutationResult<
  Blob,
  Error,
  string
> =>
  useMutation({
    mutationKey: PURCHASE_ORDER_PDF_PREVIEW_KEY,
    mutationFn: getPurchaseOrderPdfPreview,
  });
